import { render, staticRenderFns } from "./prev-common-option.vue?vue&type=template&id=497402d9&scoped=true"
import script from "./prev-common-option.vue?vue&type=script&lang=js"
export * from "./prev-common-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497402d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('497402d9')) {
      api.createRecord('497402d9', component.options)
    } else {
      api.reload('497402d9', component.options)
    }
    module.hot.accept("./prev-common-option.vue?vue&type=template&id=497402d9&scoped=true", function () {
      api.rerender('497402d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-block-form/components/prev-common-option.vue"
export default component.exports